import { NavStepState } from './enums/navStepState';
import { ContactUploadStep } from './enums/contactUploadStep';
import { ContactUploadStatus } from './enums/contactUploadStatus';
import _ from 'lodash';
import { ContactUploadAction } from './enums/contactUploadAction';

export function getContactUploadStates(
  currentStep: number,
  highestStep: number,
  contactUpload: any
): any {
  const completeSteps = {} as any;
  // TODO :  Check import type here to mark as complete
  completeSteps[ContactUploadStep.Start] =
    contactUpload.fileName &&
    contactUpload.blobPath &&
    (contactUpload.action !== ContactUploadAction.OptOut
      ? contactUpload.permission
      : true) &&
    contactUpload.action
      ? NavStepState.Complete
      : NavStepState.Enabled;
  completeSteps[ContactUploadStep.ConfirmHeaders] = getConfirmHeadersState(
    contactUpload,
    currentStep,
    completeSteps
  );
  completeSteps[ContactUploadStep.MapData] = getMapDataState(
    contactUpload,
    currentStep,
    highestStep,
    completeSteps
  );
  completeSteps[ContactUploadStep.NumberLookups] = getNumberLookupsState(
    contactUpload,
    currentStep,
    highestStep,
    completeSteps
  );
  completeSteps[ContactUploadStep.Import] = getImportState(
    contactUpload,
    currentStep,
    completeSteps
  );
  return completeSteps;
}

export function getContinueToolTip(
  currentStep: number,
  contactUpload: any
): string {
  switch (currentStep) {
    case ContactUploadStep.Start: {
      if (!contactUpload.blobPath && !contactUpload.fileName) {
        return 'Upload a file to continue';
      } else if (!contactUpload.action) {
        return 'Select an option to continue';
      } else if (
        !contactUpload.permission &&
        contactUpload.action !== ContactUploadAction.OptOut
      ) {
        return 'Confirm contact permissions before continuing';
      } else if (contactUpload.isFileFormatError) {
        return 'There seems to be a formatting error within your CSV. Please review and resubmit.';
      }
      break;
    }
    case ContactUploadStep.ConfirmHeaders: {
      if (!contactUpload.contentApproved) return 'Select an option to continue';
      break;
    }
    case ContactUploadStep.MapData: {
      if (!isPhoneMapped(contactUpload))
        return 'Mobile number field is required.';
      break;
    }
    case ContactUploadStep.NumberLookups: {
      if (contactUpload.shouldNumberLookup == null)
        return 'Please agree or disagree to your number clean up charge.';
      if (contactUpload.shouldNumberLookup && !contactUpload.hasPaymentDetails)
        return 'Please upload a credit card to proceed with number lookups.';
      break;
    }
    case ContactUploadStep.Import: {
      if (contactUpload.status === ContactUploadStatus.Submitted) {
        return 'This import has already been submitted. Please wait while we process your submission.';
      } else if (contactUpload.status === ContactUploadStatus.Complete) {
        return 'This import has already been completed.';
      }
      break;
    }
    default:
      return '';
  }
}

function getConfirmHeadersState(contactUpload, currentStep, completeSteps) {
  if (contactUpload.contentApproved) {
    return NavStepState.Complete;
  }
  if (
    currentStep > ContactUploadStep.Start &&
    completeSteps[ContactUploadStep.Start] === NavStepState.Complete
  ) {
    return NavStepState.Enabled;
  }
  return NavStepState.Disabled;
}

function getMapDataState(
  contactUpload,
  currentStep,
  highestStep,
  completeSteps
) {
  if (
    highestStep > ContactUploadStep.ConfirmHeaders &&
    isPhoneMapped(contactUpload)
  ) {
    return NavStepState.Complete;
  } else if (
    currentStep > ContactUploadStep.ConfirmHeaders &&
    completeSteps[ContactUploadStep.ConfirmHeaders] === NavStepState.Complete
  ) {
    return NavStepState.Enabled;
  } else {
    return NavStepState.Disabled;
  }
}

function getNumberLookupsState(
  contactUpload,
  currentStep,
  highestStep,
  completeSteps
) {
  const needsPaymentDetails =
    contactUpload.shouldNumberLookup && !contactUpload.hasPaymentDetails;
  if (
    highestStep > ContactUploadStep.MapData &&
    contactUpload.shouldNumberLookup != null &&
    !needsPaymentDetails
  )
    return NavStepState.Complete;

  if (
    currentStep > ContactUploadStep.MapData &&
    completeSteps[ContactUploadStep.MapData] === NavStepState.Complete
  )
    return NavStepState.Enabled;

  return NavStepState.Disabled;
}

function getImportState(contactUpload, currentStep, completeSteps) {
  if (contactUpload.status === ContactUploadStatus.Complete) {
    return NavStepState.Complete;
  }

  if (contactUpload.status === ContactUploadStatus.Submitted) {
    return NavStepState.InProgress;
  }

  if (
    currentStep > ContactUploadStep.NumberLookups &&
    completeSteps[ContactUploadStep.NumberLookups] === NavStepState.Complete
  ) {
    return NavStepState.Enabled;
  }

  if (
    currentStep > ContactUploadStep.NumberLookups &&
    contactUpload.action === ContactUploadAction.OptOut
  ) {
    return NavStepState.Enabled;
  }

  return NavStepState.Disabled;
}

function isPhoneMapped(contactUpload) {
  return _.isEmpty(contactUpload.fileUploadColumnMapping)
    ? false
    : contactUpload.fileUploadColumnMapping.find(x => x.columnId === 'phone');
}
